// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'
import getNewModulationErrorsByModulationSchemeDescription from './getNewModulationErrorsByModulationSchemeDescription'
import getRadioDetailsSubmitErrors from './getRadioDetailsSubmitErrors'

import {
  setSubmitFailed,
  stopSubmit,
} from 'redux-form'

const assignModulationDetailsErrorsFromRadioDetails = (modulationDetailsFormName, modulationData) => dispatch => {
  const radioDetailsSubmitErrors = dispatch(getRadioDetailsSubmitErrors())

  // if there are no errors for us to worry about, get outta here
  if (!radioDetailsSubmitErrors?._apiErrors?.errors?.length) {
    return
  }

  const {
    errors,
    message,
  } = radioDetailsSubmitErrors._apiErrors

  const radioModulationId = castToFloat(modulationData.radioModulationId)

  const modulationErrors = (
    radioModulationId === null
      ? dispatch(getNewModulationErrorsByModulationSchemeDescription(errors, modulationData.modulationSchemeDescription))
      : errors.find(d => d.entityId === radioModulationId) || null
  )

  // if we found no errors for this given modulation, get outta here
  if (modulationErrors === null) {
    return
  }

  // we're tricking redux-form into thinking that the modulation details form has failed a submit
  // and we're passing it the errors to use for the form.
  // This way we can mirror the behavior that we'd see on a form which actually failed submit validation
  const submitErrors = {
    _apiErrors: {
      errors: [modulationErrors],
      message,
    },
  }

  dispatch(setSubmitFailed(modulationDetailsFormName))
  dispatch(stopSubmit(modulationDetailsFormName, submitErrors))
}

export default assignModulationDetailsErrorsFromRadioDetails
